import React from 'react';
import styles from './DataCell.module.scss';

const EmptyDataCell = () => <div className={styles.EmptyDataCell}>No Data</div>;

export default EmptyDataCell;
